import { useApp } from '@/context/AppContext';
import AddCustomerModal from './modals/AddCustomerModal';
import LogChemModal from './modals/LogChemModal';
import AddInvoiceModal from './modals/AddInvoiceModal';
import StopDetailModal from './modals/StopDetailModal';
import TechnicianModal from './modals/TechnicianModal';
import WorkOrderModal from './modals/WorkOrderModal';
import AddStopModal from './modals/AddStopModal';
import SendMessageModal from './modals/SendMessageModal';
import ExportModal from './modals/ExportModal';
import StopPhotosModal from './modals/StopPhotosModal';
import ExtraChargeModal from './modals/ExtraChargeModal';
import ImportCustomersModal from './modals/ImportCustomersModal';

export default function Modal() {
  const { modal, closeModal } = useApp();
  if (!modal) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) closeModal();
  };

  const content = (() => {
    switch (modal.type) {
      case 'add_customer':  return <AddCustomerModal data={modal.data} />;
      case 'log_chem':      return <LogChemModal data={modal.data} />;
      case 'add_invoice':   return <AddInvoiceModal data={modal.data} />;
      case 'stop_detail':   return <StopDetailModal data={modal.data} />;
      case 'technician':    return <TechnicianModal data={modal.data} />;
      case 'work_order':    return <WorkOrderModal data={modal.data} />;
      case 'add_stop':      return <AddStopModal data={modal.data} />;
      case 'send_message':  return <SendMessageModal data={modal.data} />;
      case 'export':        return <ExportModal data={modal.data} />;
      case 'stop_photos':   return <StopPhotosModal data={modal.data} />;
      case 'extra_charge':       return <ExtraChargeModal data={modal.data} />;
      case 'import_customers':   return <ImportCustomersModal data={modal.data} />;
      default:                   return null;
    }
  })();

  if (!content) return null;

  return (
    <div className="overlay" onClick={handleOverlayClick}>
      {content}
    </div>
  );
}
